import { useState } from 'react';
import type { CampaignOperationalStatus } from '@/api/types';
import { useApplyRemediation, usePreviewRemediation } from '@/api/config-hooks';
import { MutationErrorLine } from '@/components/error-panel';
import { canApply } from '@/lib/remediation-view';

/** Uses the existing preview/apply contract and campaign edit authorization. */
export function CampaignRecoveryAction({ campaignId, status }: { campaignId: string; status?: CampaignOperationalStatus | null }) {
  const preview = usePreviewRemediation();
  const apply = useApplyRemediation();
  const [typed, setTyped] = useState('');
  const recovery = status?.recovery;
  if (!recovery?.can_retry || recovery.status !== 'blocked') return null;
  const target = { entity_kind: 'campaign' as const, entity_id: campaignId, target: 'meta' as const, nonce: null, operation_id: recovery.operation_id };
  const current = preview.data?.target.operation_id === recovery.operation_id ? preview.data : undefined;
  return <div className="facet" style={{ marginBottom: 12 }}>
    <button className="btn btn-sm" disabled={preview.isPending || apply.isPending} onClick={() => {
      setTyped(''); apply.reset(); void preview.mutateAsync({ action: 'retry_binding_repair', target }).catch(() => {});
    }}>Retry recovery</button>
    <MutationErrorLine error={preview.error ?? apply.error}/>
    {current && <div>
      <p>{current.reason}</p>
      {current.verdict === 'ready' && <>
        <label>Type <code>{current.confirmation}</code> to retry
          <input aria-label="Recovery confirmation" value={typed} onChange={(e) => setTyped(e.target.value)}/>
        </label>
        <button className="btn btn-sm" disabled={!canApply(current, typed, apply.isPending)} onClick={() => {
          void apply.mutateAsync({ action: 'retry_binding_repair', target, confirmation: typed, state_fingerprint: current.state_fingerprint })
            .then(() => { setTyped(''); preview.reset(); }).catch(() => {});
        }}>Confirm retry</button>
      </>}
    </div>}
    {apply.isSuccess && <p>Recovery queued. The requested campaign state is unchanged.</p>}
  </div>;
}
